export default {
	name: 'wspdsc01-product-description',
	props: {
		specifications: {
			type: Array,
			required: true
		}
	},
	computed: {
		staticDescriptions() {
			return this.specifications
				.filter(specification => specification.htmlContent)
				.map(specification => specification.htmlContent);
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/WSPDSC01-product-description/WSPDSC01-product-description.js